
import * as ipxRuntime$jJ9WvOAs59 from '/codebuild/output/src2093463017/src/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [
    "d1ma7tzlswibx6.cloudfront.net",
    "www.andyguitar.co.uk"
  ],
  "alias": {},
  "densities": [
    1,
    2,
    1,
    2
  ],
  "format": [
    "webp",
    "avif",
    "jpg",
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$jJ9WvOAs59, defaults: {"baseURL":"https://d1xinv585j1o97.cloudfront.net/"} }
}
        